import {
  Badge,
  Button,
  CloseButton,
  Dialog,
  HStack,
  Heading,
  Portal,
  Text,
  VStack,
} from "@chakra-ui/react";
import { statusMessagesMapping } from "../../../../constants/paymentStatusMessages";
import { formatUtcDatetimeToColombian } from "../../../../helpers/time";
import { Payment } from "../../../../types/types";

const TYPES = {
  pse: {
    label: "PSE",
    colorPalette: "green",
  },
  nequiButton: {
    label: "Botón Nequi",
    colorPalette: "purple",
  },
  bancolombiaButton: {
    label: "Botón Bancolombia",
    colorPalette: "yellow",
  },
  card: {
    label: "Tarjeta",
    colorPalette: "blue",
  },
  breb: {
    label: "Bre-B",
    colorPalette: "red",
  },
};

type Props = {
  open: boolean;
  onClose: () => void;
  unsuccessfulPayments?: Payment[];
};

const UnsuccessfulPaymentsModal = ({
  open,
  onClose,
  unsuccessfulPayments,
}: Props): JSX.Element => {
  if (!unsuccessfulPayments) return <></>;

  return (
    <Dialog.Root
      open={open}
      onOpenChange={(e) => !e.open && onClose()}
      size="xl"
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header borderBottom="1px solid #ebecef80" padding="4">
              <Dialog.Title>
                <Heading>Pagos Fallidos</Heading>
              </Dialog.Title>
            </Dialog.Header>
            <Dialog.CloseTrigger asChild>
              <CloseButton marginTop="1" onClick={onClose} />
            </Dialog.CloseTrigger>
            <Dialog.Body py={6}>
              <HStack gap={6} align="stretch">
                <VStack gap={4} align="start" flex="1" justify="space-between">
                  {unsuccessfulPayments.map((payment) => (
                    <Text key={payment.date} fontWeight={550} color="gray.600">
                      {formatUtcDatetimeToColombian(payment.date)}
                    </Text>
                  ))}
                </VStack>
                <VStack gap={4} align="center" flex="1" justify="space-between">
                  {unsuccessfulPayments.map((payment) => (
                    <Badge
                      key={payment.date}
                      colorPalette={
                        TYPES[payment.type as keyof typeof TYPES]
                          ?.colorPalette || "gray"
                      }
                      my="5px"
                    >
                      {TYPES[payment.type as keyof typeof TYPES]?.label}
                    </Badge>
                  ))}
                </VStack>
                <VStack gap={4} align="end" flex="1" justify="space-between">
                  {unsuccessfulPayments.map((payment) => (
                    <Badge key={payment.date} colorPalette="red" my="5px">
                      {statusMessagesMapping[payment.statusMessage!]}
                    </Badge>
                  ))}
                </VStack>
              </HStack>
            </Dialog.Body>
            <Dialog.Footer borderTop="1px solid #ebecef80">
              <Button onClick={onClose}>Cerrar</Button>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default UnsuccessfulPaymentsModal;
